var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamPermissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDB41"
    },
    d: "M205.035,299.104H20V196.999c0-24.472,19.909-44.381,44.381-44.381h96.273 c24.472,0,44.381,19.909,44.381,44.381L205.035,299.104L205.035,299.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M205.035,299.104h-92.518V152.618h48.136c24.472,0,44.381,19.909,44.381,44.381L205.035,299.104 L205.035,299.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDB41"
    },
    d: "M112.518,129.823c-29.058,0-52.699-23.641-52.699-52.699s23.641-52.699,52.699-52.699 s52.699,23.641,52.699,52.699C165.216,106.182,141.576,129.823,112.518,129.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M112.518,129.823V24.425c29.058,0,52.699,23.641,52.699,52.699 C165.216,106.182,141.576,129.823,112.518,129.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE7858"
    },
    d: "M491.407,299.104H306.372V196.999c0-24.472,19.909-44.381,44.381-44.381h96.273 c24.472,0,44.381,19.909,44.381,44.381L491.407,299.104L491.407,299.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD4E26"
    },
    d: "M491.407,299.104H398.89V152.618h48.136c24.472,0,44.381,19.909,44.381,44.381V299.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE7858"
    },
    d: "M398.89,129.823c-29.058,0-52.699-23.641-52.699-52.699s23.641-52.699,52.699-52.699 s52.699,23.641,52.699,52.699C451.589,106.182,427.948,129.823,398.89,129.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD4E26"
    },
    d: "M398.89,129.823V24.425c29.058,0,52.699,23.641,52.699,52.699 C451.589,106.182,427.948,129.823,398.89,129.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81C8EE"
    },
    d: "M356.744,299.104H155.256V187.92c0-26.648,21.68-48.328,48.328-48.328h104.833 c26.648,0,48.328,21.68,48.328,48.328v111.184H356.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#159CE4"
    },
    d: "M356.744,299.104H256V139.592h52.417c26.648,0,48.328,21.68,48.328,48.328v111.184H356.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81C8EE"
    },
    d: "M256,114.77c-31.642,0-57.385-25.743-57.385-57.385S224.358,0,256,0s57.385,25.743,57.385,57.385 S287.642,114.77,256,114.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#159CE4"
    },
    d: "M256,114.77V0c31.642,0,57.385,25.743,57.385,57.385S287.642,114.77,256,114.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C6CD"
    },
    d: "M20,276v33.943l67.947,7.195c4.238,17.374,11.1,33.719,20.143,48.592l-42.968,53.146l48.003,48.003 l53.146-42.968c14.874,9.042,31.219,15.905,48.592,20.143L222.057,512h67.886l7.195-67.947c17.374-4.238,33.719-11.1,48.592-20.143 l53.146,42.968l48.003-48.003L403.91,365.73c9.042-14.874,15.905-31.219,20.143-48.592L492,309.943V276H20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M256,276v236h33.943l7.195-67.947c17.374-4.238,33.719-11.1,48.592-20.143l53.146,42.968 l48.003-48.003L403.91,365.73c9.042-14.874,15.905-31.219,20.143-48.592L492,309.943V276H256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8892"
    },
    d: "M155.256,276c0,55.64,45.105,100.744,100.744,100.744S356.744,331.64,356.744,276H155.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787780"
    },
    d: "M256,276v100.744c55.64,0,100.744-45.105,100.744-100.744H256z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPermissions);
export default __webpack_public_path__ + "static/media/team-permissions.e5d9480d225ae355b7a2b5e26727c0df.svg";
export { ForwardRef as ReactComponent };